module.exports = __webpack_public_path__ + "static/img/4.b2db88f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/4.png
// module id = iE3j
// module chunks = 0